import React from "react";
import { ROUTE_PATH } from "../../app/constants";
import { Header, NavigationLinkButton, Paragraph } from "../../components/RegularComponents";
import './HasWorkExperienceQuestionView.scss'


export const MraNoWorkExperience = () => {
    return (
        <>
            <div className="container">
                <div className="row bottomMarginMedium">
                    <div className="col-lg-8">
                        <Header 
                            id="no-work-experience-header"
                            header={"Choose a new principal broker"}
                        />
                    </div>
                </div>
                <div className="row bottomMarginMedium">
                    <div className="col-lg-8">
                        <Paragraph 
                            id="no-work-experience-text"
                            text={[
                                "The principal broker for your brokerage must meet at least 1 of the following criteria:",
                                `<ul class="dashed spaced">
                                    <li>You brokered mortgages under a licensed brokerage for at least 24 of the past 36 months</li>
                                    <li>You brokered mortgages as a licensed individual for at least 24 of the past 36 months</li>
                                    <li>You have a current Mortgage Broker licence or equivalent in one of the following provinces:
                                        <ul class="dashed indented">
                                            <li>Alberta</li>
                                            <li>British Columbia</li>
                                            <li>Manitoba</li>
                                            <li>New Brunswick</li>
                                            <li>Ontario</li>
                                            <li>Quebec</li>
                                            <li>Saskatchewan</li>
                                            <li>Nova Scotia</li>
                                        </ul>
                                    </li>
                                    <li>You are exempt because you brokered mortgages for a federally regulated financial institution.</li>
                                </ul>`,
                            "Choose a new principal broker for your company."
                            ]}
                        />
                    </div>
                </div>

                <div className="row bottomMarginNormal">
                <div className="col-lg-8">
                     <NavigationLinkButton 
                        onClick={() => {
                            window.location.assign(ROUTE_PATH.LAUNCHPAGE_MORTGAGE)
                        }}
                        text="Back to start"
                    />
                </div>
            </div>
            </div>
        </>
    )
}